import { render, staticRenderFns } from "./ExtendProyek.vue?vue&type=template&id=454e4f14&scoped=true"
import script from "./ExtendProyek.vue?vue&type=script&lang=js"
export * from "./ExtendProyek.vue?vue&type=script&lang=js"
import style0 from "./ExtendProyek.vue?vue&type=style&index=0&id=454e4f14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454e4f14",
  null
  
)

export default component.exports